export default __webpack_public_path__ + "static/media/dog6.d5ca427c.JPG";